const { CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT } = require('@/enums');

module.exports = (s) => {
  return {
    // 广告平台
    advertiser: {
      type: 'select',
      props: {
        placeholder: '请选择广告平台',
      },
      options: [
        { label: '广点通', value: 'gdt' },
        { label: '今日头条', value: 'jrtt' },
        { label: '今日头条体验版', value: 'jrttnew' },
        { label: '百度信息流', value: 'baidu' },
        { label: 'B站三连推广', value: 'bilibili' },
        { label: CHANNEL_INTERFACE_TEXT.HUAWEI, value: CHANNEL_INTERFACE_TYPE.HUAWEI },
        { label: CHANNEL_INTERFACE_TEXT.OPPO, value: CHANNEL_INTERFACE_TYPE.OPPO },
        { label: CHANNEL_INTERFACE_TEXT.VIVO, value: CHANNEL_INTERFACE_TYPE.VIVO },
        { label: CHANNEL_INTERFACE_TEXT.XIAOMI, value: CHANNEL_INTERFACE_TYPE.XIAOMI },
      ],
      value: 'gdt',
      on: {
        'change': s.getMediasList,
      },
    },

    // 广告主id
    advertiser_id: {
      type: 'select',
      props: {
        placeholder: '请选择广告主',
      },
      options: [],
      value: '',
    },
    // 计划状态
    status: {
      type: 'select',
      props: {
        placeholder: '请选择计划状态',
      },
      options: [
        { label: '提交', value: 1 },
        { label: '成功', value: 2 },
        { label: '失败', value: 3 },
      ],
      value: '',
    },
    // 计划名称
    name: {
      type: 'input',
      props: {
        placeholder: '请输入计划名称',
      },
      width: '300px',
      value: '',
    },
  };
};

